import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SidebarService } from "./core/services/sidebar.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { LazyLoadingComponent } from "./shared/components/lazy-loading/lazy-loading.component";
import { ThemeService } from "./core/services/theme.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, DragDropModule, LazyLoadingComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  providers: [MatSnackBar]
})
export class AppComponent {
  title = "instalcorp-frontend";

  constructor(private sidebarService: SidebarService, private themeService: ThemeService) {
    this.themeService.init();
  }
}
